<div class="hx-accordion__container">
  <ng-content />
</div>
